import { render, staticRenderFns } from "./statisticalQuery.vue?vue&type=template&id=424d3fd8&scoped=true&"
import script from "./statisticalQuery.vue?vue&type=script&lang=js&"
export * from "./statisticalQuery.vue?vue&type=script&lang=js&"
import style0 from "./statisticalQuery.vue?vue&type=style&index=0&id=424d3fd8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424d3fd8",
  null
  
)

export default component.exports